import axiosInstance from '@/api/axiosInstance';

// Get all watches (favorites) for the current user
export const getWatches = async (cursor) => {
  const params = {};
  
  if (cursor) {
    params.cursor = cursor;
  }
  
  const response = await axiosInstance.get('/users/me/watches', { params });
  return response.data;
};

// Add watches for PSA single cards and card boxes
export const updateCardWatches = async (productId, type, options) => {
  const payload = {
    type,
    productId
  };

  // Add appropriate options based on type
  if (type === 'PSA_SINGLE_CARD') {
    payload.psaGrades = options;
  } else if (type === 'CARD_BOX') {
    payload.bundledQuantities = options;
  }

  const response = await axiosInstance.put('/users/me/watches', payload);
  return response.data;
};

// Add watch for non-PSA single card
export const addNonPsaWatch = async (productId, listingId) => {
  const payload = {
    type: 'NON_PSA_SINGLE_CARD',
    productId,
    listingId
  };

  const response = await axiosInstance.post('/users/me/watches', payload);
  return response.data;
};

// Remove watch for non-PSA single card
export const removeNonPsaWatch = async (productId, listingId) => {
  const payload = {
    type: 'NON_PSA_SINGLE_CARD',
    productId,
    listingId
  };

  const response = await axiosInstance.delete('/users/me/watches', { data: payload });
  return response.data;
}; 